module.exports = __webpack_public_path__ + "img/observation.828975fc.png";